// extracted by css-extract-rspack-plugin
var _1 = "la";
var _2 = "ll";
var _3 = "ib";
var _4 = "lk";
var _5 = "lm";
var _6 = "e0";
var _7 = "be";
export { _1 as "iconBaseComponent", _2 as "iconItem", _3 as "imageContainer", _4 as "innerContent", _5 as "message", _6 as "title", _7 as "userCommunicationTemplateComponent" }
